import { AnswerModel } from '@/components/decision-tree/hooks';
import { ChangeEvent } from 'react';
import { useForm } from 'react-hook-form';
import { FreetextAnswer, FreetextValidation } from './types';

type FreetextControllerProps = {
  validationValues?: FreetextValidation;
  saveAnswer: (payload: AnswerModel) => void;
  defaultValue?: FreetextAnswer;
};

export default function useFreetextController({ validationValues, saveAnswer, defaultValue }: FreetextControllerProps) {
  const form = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues: { freetext: defaultValue?.value || '' },
  });

  const validationOptions = {
    required: validationValues?.required,
  };

  const onInputFn = ({ currentTarget }: ChangeEvent<HTMLInputElement>) => {
    form.setValue('freetext', currentTarget.value);

    if (currentTarget.value) {
      saveAnswer({ type: 'freetext', value: currentTarget.value });
    }
  };

  const onBlurFn = ({ currentTarget }: ChangeEvent<HTMLInputElement>) => {
    form.setValue('freetext', currentTarget.value);

    // Save the answer only if the value is not empty
    if (currentTarget.value) {
      saveAnswer({ type: 'freetext', value: currentTarget.value });
    }
  };

  return { onInputFn, form, validationOptions, onBlurFn };
}
